import { RouteComponentProps } from "@reach/router"
// Styles
import { SimpleTable_s } from 'components/dashboard/dashboard-styles'
// Components
import ConfirmationModal from "components/modal/confirmation-modal"
// Data
import exportService from "data/export"
import propertyService from "data/property"
import { CommercialIcon, FolderIcon, HospitalityIcon, MFRentIcon, MixedUseIcon } from 'images/icons/sidebar/'
// Icons 
import { DeleteIcon, DownloadIcon } from 'images/icons/tools/'
import _ from "lodash"
import Moment from 'moment'
import React, { FC, useEffect, useState } from "react"
import Isvg from 'react-inlinesvg'

const BIDataExportWidget: FC<RouteComponentProps> = (props) => {
  const [exports, setExports]       = useState<object[]>([])
  const [currentExport, setExport]  = useState<object>({})
  const [properties, setProperties] = useState<object[]>([])
  const [show, setShow]             = useState<boolean>(false)

  useEffect(() => {
    exportService.getBIDataExports().then((res)=>{
      setExports(res)
      let properties:any = []
      for (let i of res){
        if (i['propertyid']) propertyService.fetchProperty(i['propertyid']).then(property => properties.push(property))
      }
      setProperties(properties)
    })
  }, []);

  useEffect(() => {
    let propertyIds = exports.filter(exp => exp['propertyid']).map(exp => exp['propertyid'])
    propertyService.fetchProperties(propertyIds).then((properties:any) => {
      setProperties(properties)
    })
  }, [exports]);

  async function confirm(){
    toggleShow()
    await exportService.deleteExport(currentExport['filelocation'])
    exportService.getBIDataExports().then((res)=>{
      setExports(res)
    })
  }

  const toggleShow = () => setShow(!show)

  const exportTypes = [
    { name: 'inflation_increase_input', label: 'Input: Inflation/Increase'},
    { name: 'line_item_input', label: 'Input: Line Item'},
    { name: 'market_lease_input', label: 'Input: Market Lease'},
    { name: 'multifamily_rent_roll_input', label: 'Input: Multifamily Rent Roll'},
    { name: 'named_item_input', label: 'Input: Named Item'},
    { name: 'property_input', label: 'Input: Property'},
    { name: 'recovery_input', label: 'Input: Recovery'},
    { name: 'rent_roll_input', label: 'Input: Rent Roll'},
    { name: 'room_input', label: 'Input: Room'},
    { name: 'marketlease_ts', label: 'Results: Market Lease'},
    { name: 'named_item_ts', label: 'Results: Named Item'},
    { name: 'property_ts', label: 'Results: Property'},
    { name: 'room_ts', label: 'Results: Room'},
    { name: 'tenant_ts', label: 'Results: Tenant'},
    { name: 'multifamily_units_ts', label: 'Results: Units'},
  ]

  const folderIcon      = <Isvg src={FolderIcon} cacheRequests width={18} />;
  const commercialIcon  = <Isvg src={CommercialIcon} cacheGetRequests width={18} />;
  const hospitalityIcon = <Isvg src={HospitalityIcon} cacheGetRequests width={18} />;
  const mfIcon          = <Isvg src={MFRentIcon} cacheGetRequests width={13} />;
  const mixedUseIcon    = <Isvg src={MixedUseIcon} cacheRequests width={20} />;

  const getType     = (x) => _.get(exportTypes.find(exportType => exportType.name === x['reporttype']),'label', x['reporttype'])
  const icon        = (x) => x['context'] === 'folder' ? folderIcon : _.find(properties, {propertyid: x['propertyid']})?.['type'] == 'Multifamily' ? mfIcon : _.find(properties, {propertyid: x['propertyid']})?.['type'] == 'Hospitality' ? hospitalityIcon : _.find(properties, {propertyid: x['propertyid']})?.['type'] === 'Mixed-Use' ? mixedUseIcon : commercialIcon
  const deleteIcon  = (key) => <a>
    <Isvg src={DeleteIcon} cacheGetRequests width={18} />
  </a>

  return (
    <SimpleTable_s>
      <thead>
        <tr>
        <th>Download</th>
        <th>Source</th>
        <th>Path</th>
        <th>Report Type</th>
        <th>Created</th>
        <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        { exports && exports?.map(x => {
          return (
            <tr key={x['dataexportid']}>
              <td className="icon-column">
                <a onClick={()=>exportService.getExport(x['filelocation'], x['filename'])}>
                  <Isvg src={DownloadIcon} cacheGetRequests width={18} />
                </a>
              </td>
              <td className="icon-column">{icon(x)}</td>
              <td>{x['exportpath']}</td>
              <td>{getType(x)}</td>
              <td>{Moment.tz(Moment.utc(x['requestcomplete']), Moment.tz.guess()).format('MM/DD/YYYY h:mm A z')}</td>
              <td className="icon-column"><a onClick={()=>{setShow(true); setExport(x)}}>{deleteIcon(x['filelocation'])}</a></td>
            </tr>
          )
        })}
      </tbody>
      <ConfirmationModal
        height={100}
        width={600}
        contentHeight={50}
        show={show}
        toggleShow={toggleShow}
        title={"Delete Confirmation"}
        confirmText={"Delete"}
        message={""}
        confirmFunc={confirm}
        cancelFunc={toggleShow}
        confirmOnly={false}
        closeOnly={false}>
        <span>{`Are you sure that you want to delete the export ${currentExport?.['filename']}?`}</span>
      </ConfirmationModal>
    </SimpleTable_s>
  )
}

export default BIDataExportWidget
